import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentContext = createContext({
  content: null,
  loading: true,
  refresh: async () => {},
});

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/cms/content`);
      setContent(data);
    } catch (e) {
      console.error("Failed to load CMS content", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

// Hook that returns a specific section's data (or null while loading)
export const useContent = (key) => {
  const { content, loading, refresh } = useContext(ContentContext);
  return {
    data: content ? content[key] : null,
    loading,
    refresh,
  };
};

export const useAllContent = () => useContext(ContentContext);

// Resolve an image URL that may be a CMS file id path (/api/cms/files/xxx)
// or an absolute URL. Prefixes backend URL if it starts with /api.
export const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) {
    return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  }
  return url;
};
